import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { BRAND_FULL_NAME } from '../../config/brand';
import { useAuth } from '../../contexts/AuthContext';

const StarOrnament: React.FC<{ className?: string }> = ({ className = '' }) => (
  <svg
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden
  >
    <path
      d="M60 8 L68 40 L98 28 L80 52 L112 60 L80 68 L98 92 L68 80 L60 112 L52 80 L22 92 L40 68 L8 60 L40 52 L22 28 L52 40 Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinejoin="round"
    />
    <path
      d="M60 28 L64 48 L82 40 L70 56 L90 60 L70 64 L82 80 L64 72 L60 92 L56 72 L38 80 L50 64 L30 60 L50 56 L38 40 L56 48 Z"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinejoin="round"
      opacity="0.7"
    />
  </svg>
);

const HomeCtaBanner: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <section id="home-cta-section" className="relative overflow-hidden bg-green-800 py-16 sm:py-20 lg:py-24">
      <StarOrnament className="pointer-events-none absolute -end-6 bottom-0 h-44 w-44 text-gold-400/20 sm:h-64 sm:w-64 lg:h-80 lg:w-80" />
      <StarOrnament className="pointer-events-none absolute -start-10 -top-8 h-32 w-32 text-[#f4f1ea]/10 sm:h-44 sm:w-44" />

      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <p className="mb-4 text-[11px] font-semibold tracking-[0.2em] text-gold-300 sm:text-xs">ابدأ دلوقتي</p>
        <h3 className="max-w-3xl font-thmanyah text-[clamp(1.7rem,4vw,3.25rem)] font-bold leading-[1.2] text-[#f4f1ea]">
          مستعد تبدأ مذاكرتك مع {BRAND_FULL_NAME}؟
        </h3>
        <span className="mt-5 mb-6 block h-px w-14 bg-gold-500" aria-hidden />
        <p className="mb-8 max-w-xl text-sm leading-relaxed text-[#eef4f1]/85 sm:mb-10 sm:text-base sm:leading-7">
          اختار مدرسك والكورسات المناسبة لصفك، وابدأ بالطريقة اللي تناسبك.
        </p>

        <div className="flex flex-col gap-3 sm:flex-row sm:gap-4">
          {mounted && !isAuthenticated ? (
            <button
              type="button"
              onClick={() => navigate('/register')}
              className="inline-flex min-h-12 w-full items-center justify-center gap-2 rounded-full bg-gold-500 px-7 text-sm font-semibold text-green-950 transition-colors hover:bg-gold-400 sm:w-auto sm:text-base"
            >
              سجّل مجاناً
              <ArrowLeft className="h-4 w-4" aria-hidden />
            </button>
          ) : mounted && isAuthenticated ? (
            <button
              type="button"
              onClick={() => navigate('/student-portal')}
              className="inline-flex min-h-12 w-full items-center justify-center gap-2 rounded-full bg-gold-500 px-7 text-sm font-semibold text-green-950 transition-colors hover:bg-gold-400 sm:w-auto sm:text-base"
            >
              ادخل لمنصتك
              <ArrowLeft className="h-4 w-4" aria-hidden />
            </button>
          ) : null}
          <button
            type="button"
            onClick={() =>
              document.getElementById('suggested-courses-section')?.scrollIntoView({ behavior: 'smooth' })
            }
            className="inline-flex min-h-12 w-full items-center justify-center rounded-full border border-[#f4f1ea]/70 px-7 text-sm font-semibold text-[#f4f1ea] transition-colors hover:bg-[#f4f1ea]/10 sm:w-auto sm:text-base"
          >
            شوف الكورسات
          </button>
        </div>
      </div>
    </section>
  );
};

export default HomeCtaBanner;
